import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { DOMAIN_CONTROL } from 'constants/billing_features'
import { isAvailableFeatureSelector } from 'features/billing'
import { domainControlSettingLoadingSelector, getDomainControlSettingForOrg } from 'features/organization_settings/index'

import { LoadingModal } from '../loading_modal'
import { isRemovePopupOpenSelector, isBatchRemovalSelector } from '../selectors'
import { RemoveSelectedUsers } from './remove_selected_users'
import { RemoveUser } from './remove_user'


export const RemovePopup = () => {
  const dispatch = useDispatch()
  const isBatchRemoval = useSelector(isBatchRemovalSelector)
  const isDomainControlFeatureAvailable = useSelector((state) => isAvailableFeatureSelector(state, { featureKey: DOMAIN_CONTROL }))
  const isOpen = useSelector(isRemovePopupOpenSelector)
  const domainControlSettingLoading = useSelector(domainControlSettingLoadingSelector)

  useEffect(() => {
    if (isOpen && isDomainControlFeatureAvailable) {
      dispatch(getDomainControlSettingForOrg())
    }
  }, [dispatch, isDomainControlFeatureAvailable, isOpen])


  if (domainControlSettingLoading) {
    return <LoadingModal />
  }


  return isBatchRemoval ? <RemoveSelectedUsers /> : <RemoveUser />
}
